// Protección de consola en producción
export const disableConsole = () => {
  if (process.env.NODE_ENV === 'production') {
    // Deshabilitar console.log, console.warn, console.error
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.debug = () => {};
    console.info = () => {};
    
    // Mensaje de advertencia si intentan usar la consola
    Object.defineProperty(window, 'console', {
      get: function() {
        return {
          log: () => {},
          warn: () => {},
          error: () => {},
          debug: () => {},
          info: () => {},
          clear: () => {},
          dir: () => {},
          dirxml: () => {},
          table: () => {},
          trace: () => {},
          group: () => {},
          groupCollapsed: () => {},
          groupEnd: () => {},
          time: () => {},
          timeEnd: () => {},
          timeLog: () => {},
          assert: () => {},
          count: () => {},
          countReset: () => {}
        };
      },
      set: function() {}
    });
  }
};

// Detectar DevTools abierto
export const detectDevTools = () => {
  if (process.env.NODE_ENV === 'production') {
    const threshold = 160;
    
    setInterval(() => {
      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold
      ) {
        // DevTools detectado - podrías redirigir o mostrar advertencia
        console.clear();
      }
    }, 1000);
  }
};
